import {pathname} from "../../../Assets/javascripts/common/others/Configuration";
import $ from "jquery";

export default class {
  static destroy(){
    var destroyURL = pathname + '/api/home/v1/RemoveAllLastSeenItems';
    var destroyOptions = {
      url: destroyURL,
      type: "post",
      data: JSON.stringify({}),
      dataType: "json"
    };

    return $.ajax(destroyOptions);
  }
}
